/*
 * survey.js 06.03.2018
 *
 * (c) 2018 ergovia GmbH
 */

/* global localStorage */

import {CLOSE_SURVEY_DIALOG, SAVE_SHOW_SURVEY_DIALOG} from '../actions/types';

const surveyState = (state = { type: '',
    lastFetchedAndShown: null,
    webLink: '',
    description: '',
    open: false,
    initial: true}, action) => {

    switch (action.type) {
        case SAVE_SHOW_SURVEY_DIALOG:

            if (action.webLink !== localStorage.getItem('bimanWebLink')) {

                localStorage.setItem('bimanWebLink',action.webLink);
                return {
                    type: action.type,
                    lastFetchedAndShown: action.lastFetchedAndShown,
                    webLink: action.webLink,
                    description: action.description,
                    open: true,
                    initial: false
                };
            }

            return state;

        case CLOSE_SURVEY_DIALOG:
            return {
                open: action.open
            };

        default:
            return state;

    }

};

export default surveyState;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/survey.js